export default "__VITE_ASSET__c81206d0__"